import cn from "classnames";
import "./ContactInfoCardBlock.scss";
import { ContactInfoCardBlockProps } from "/Models/Generated/ContactInfoCardBlockProps";
import {
  ArrowLineUpRightIcon,
  BlockTop,
  Link,
  OptimizelyEditProperty,
} from "/App.Components";
import { ContentAreaType } from "/Models/Generated/ContentAreaType";
import EmailContactRow from "/Components/Shared/EmailContactRow/EmailContactRow";

interface Props extends ContactInfoCardBlockProps {
  // Sentence-case label inline with its value, as in the organization pages design
  inlineLabels?: boolean;
}

const ContactInfoCardBlock = ({
  heading,
  headingPropertyName,
  leadText,
  leadTextPropertyName,
  items,
  itemsPropertyName,
  emailCopiedText,
  emailCopyLabel,
  contentAreaType,
  inlineLabels,
}: Props) => (
  <div
    className={cn("contact-info-card-block", {
      "contact-info-card-block--inline-labels": inlineLabels,
    })}
  >
    {(!!heading || !!headingPropertyName) && (
      <BlockTop heading={heading} headingPropertyName={heading} />
    )}
    <div className="contact-info-card-block__container">
      {(leadText || leadTextPropertyName) && (
        <p
          className={cn("contact-info-card-block__lead-text", {
            "epi-editContainer": leadTextPropertyName,
          })}
          data-epi-property-name={leadTextPropertyName}
        >
          {leadText}
        </p>
      )}
      <OptimizelyEditProperty propertyName={itemsPropertyName}>
        {(items?.length ?? 0) > 0 && (
          <ul className="contact-info-card-block__items">
            {items.map((item, idx) => (
              <li
                key={idx}
                className={cn("contact-info-card-block__item", {
                  "contact-info-card-block__item--sidebar":
                    contentAreaType === ContentAreaType.OneThird,
                })}
              >
                <div className="contact-info-card-block__item-label">
                  {item.label}
                </div>
                <div className="contact-info-card-block__value">
                  {item.email && (
                    <EmailContactRow
                      email={item.email}
                      copiedText={emailCopiedText}
                      copyLabel={emailCopyLabel}
                    />
                  )}
                  {item.phone && (
                    <Link
                      href={"tel:" + item.phone.split(" ").join("")}
                      text={item.phone}
                      isExternal={false}
                      size="x-small"
                      contained
                      hasUnderline
                    />
                  )}
                  {item.link && (
                    <Link
                      {...item.link}
                      target={item.link.isExternal ? "_blank" : undefined}
                      size="x-small"
                      contained
                      hasUnderline
                      icon={
                        item.link.isExternal ? ArrowLineUpRightIcon : undefined
                      }
                      iconThickness="Light"
                      iconPlacement="after"
                      iconSize="20"
                      fixedIcon
                    />
                  )}
                  <span className="contact-info-card-block__plain-text">
                    {item.text}
                  </span>
                </div>
              </li>
            ))}
          </ul>
        )}
      </OptimizelyEditProperty>
    </div>
  </div>
);

export default ContactInfoCardBlock;
